import Handlebars from "../handlebars/handlebars";
import jumpToMenuHtml from "../jumpToMenu/jumpToMenu.hbs"

const jumpToMenuEle = document.querySelector('.js--element-categoryJumpToMenu')
const categoryId = window.spdc.categoryId;

Collaterate.Site.getCategoryById(categoryId)
    .then(renderJumpToMenu)
    .then(inViewportChecker)

window.addEventListener('scroll', inViewportChecker);

function inViewportChecker () {        
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: [1]
    }
    
    let callback = (entries, observer) => {
        entries.forEach((entry) => {
        const jumpToNavItem = jumpToMenuEle.querySelector('.jumpToMenu-items-link-'+entry.target.id+'');

        if (entry.intersectionRatio <= 0.5) {
            jumpToNavItem.classList.remove('isActive');
        }

        if (entry.intersectionRatio > 0.5) {
            jumpToNavItem.classList.add('isActive');
        }
        });
    }
    
    let observer = new IntersectionObserver(callback, options);

    document.querySelectorAll('.categoryList').forEach( (categoryListItem) => {
        let target = categoryListItem;
        observer.observe(target);
    });
}

function renderJumpToMenu (category) {
    jumpToMenuEle.innerHTML = jumpToMenuHtml(category);
}